module.exports = __webpack_public_path__ + "static/media/bg2.c2a3c37a.jpg";